import { useRef, Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { FaTimes } from 'react-icons/fa';
import { QRCodeCanvas } from 'qrcode.react';
import { useTranslation } from 'react-i18next';

const QRCodeModal = ({ isOpen, onClose, qrValue, title, name }) => {
  const { t } = useTranslation();
  const canvasRef = useRef(null);

  const downloadQR = () => {
    if (!canvasRef.current) return;
    
    const qrCanvas = canvasRef.current;
    
    // 固定尺寸设置
    const padding = 20;
    const qrSize = 256;
    const textAreaHeight = 80; // 文字区域高度
    const canvasWidth = qrSize + padding * 2;
    const canvasHeight = qrSize + padding * 2 + textAreaHeight;

    // 创建画布
    const combinedCanvas = document.createElement('canvas');
    combinedCanvas.width = canvasWidth;
    combinedCanvas.height = canvasHeight;
    const ctx = combinedCanvas.getContext('2d');

    // 填充白色背景
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvasWidth, canvasHeight);

    // 绘制二维码
    ctx.drawImage(qrCanvas, padding, padding, qrSize, qrSize);

    // 绘制用户名
    const displayName = name || '';
    if (displayName) {
      ctx.fillStyle = '#000000';
      ctx.font = 'bold 24px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      
      const textX = canvasWidth / 2;
      const textY = qrSize + padding * 2 + 20;
      
      const textToDraw = displayName.length > 20 ? displayName.slice(0, 20) + '...' : displayName;
      ctx.fillText(textToDraw, textX, textY);
    }

    // 导出并下载
    const pngUrl = combinedCanvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    const safeName = displayName.replace(/[^a-z0-9\u4e00-\u9fa5_-]/gi, '_');
    downloadLink.download = `qrcode_${safeName || 'ecard'}.png`;
    
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="bg-black text-white flex justify-between items-center px-4 py-3 border-b">
            <h2 className="text-lg">{title}</h2>
            <button onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          <div className="p-4">
            <div className="flex flex-col items-center space-y-4">
              <QRCodeCanvas
                ref={canvasRef}
                value={qrValue || 'test'}
                size={256}
                level={'H'}
                includeMargin={true}
              />
            </div>
          </div>

          <div className="flex justify-end gap-2 px-4 py-3 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
            >
              {t('Cancel')}
            </button>
            <button
              onClick={downloadQR}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              {t('Download')}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default QRCodeModal;
